<section class="content-2">
  <div class="title-container">
    <h1 class="title">Adicional para modalidades e contextos</h1>
    <h2 class="subtitle">Adicional de recursos para modalidades e contextos específicos.</h2>
  </div>

  <hr class="division-line" />

  <div class="panel dropdown-panel">
    <app-menu-suspenso #menuTooltip="matTooltip" [matTooltip]="menuTooltipVisible ? 'Visualizar o PQR' : ''"
                       matTooltipPosition="above" (chamadaDeAcao)="chamarAcao($event)" [opcoes]="[
        {
          rotulo: 'PQR desta funcionalidade',
          icone: 'computer',
          acao: 'pqrDestaFuncionalidade'
        },
        {
          rotulo: 'Restaurar valores com base no PQR',
          icone: 'content_copy',
          acao: 'restaurarValoresComBaseNoPqr'
        },
        {
          rotulo: 'PQR completo em nova aba',
          icone: 'desktop_windows',
          acao: 'pqrCompletoEmNovaAba'
        }
      ]">
      Padrão de qualidade de referência (PQR)
    </app-menu-suspenso>

    <mat-icon class="info-icon" #infoTooltip="matTooltip" matTooltip="Informações sobre o PQR"
              matTooltipPosition="left" (mouseenter)="openTooltips()" (mouseleave)="closeTooltips()">
      info
    </mat-icon>
  </div>

  <div class="panel">
    <app-tabela ngSkipHydration class="table-component" [cabecalhoCustomizado]="true">
      <ng-container cabecalho>
        <tr>
          <th class="table-header align-center" style="width: 10%">Seq.</th>
          <th class="table-header" style="width: 50%">Item</th>
          <th *ngIf="featureFlagService.funcionalidadeHabilitada('995-fator-ponderacao-calculo.exibicao-fator-ponderacao')" class="table-header" style="width: 20%">Número de matrículas</th>
          <th class="table-header" style="width: 20%">Fator de ponderação</th>
        </tr>
      </ng-container>
      <ng-container corpo>
        <tr *ngFor="let dados of dadosTabela; index as i">
          <td class="table-cell align-left">{{ i + 1 }}</td>
          <td class="table-cell">
            <input
              class="display-input align-left"
              style="text-align: left !important;"
              type="text"
              [(ngModel)]="dados.descricaoItem"
              disabled>
          </td>
          <td *ngIf="featureFlagService.funcionalidadeHabilitada('995-fator-ponderacao-calculo.exibicao-fator-ponderacao')" class="table-cell">
            {{ totalMatriculas[i] | number:'1.0-0':'pt' }}
          </td>
          <td class="table-cell">
            <input class="display-input text-green"
                   [maskito]="mask_porcentagem_limpa_duas_casas"
                   [(ngModel)]="dados.fatorPonderacao"
                   (ngModelChange)="atualizarDadosTabela()"
                   appPtBrNumber
                   (blur)="garantirMinimoTabela(i)"
            />
          </td>
        </tr>
      </ng-container>
    </app-tabela>
  </div>
  <div class="notes-section">
    <p class="notes-text">
      <strong>Notas:</strong><br>
      <sup>(1)</sup> Considera as matrículas da Educação Profissional integradas e concomitantes ao Ensino Médio do Censo Escolar.<br>
      <sup>(2)</sup> Considera as matrículas da Educação Profissional integradas e concomitantes à EJA identificadas no Censo Escolar.<br>
      <sup>(3)</sup> Considera as matrículas do Público de Educação Especial (PEE) identificadas no Censo Escolar.
    </p>
  </div>
</section>
